import { Component } from "@angular/core";

@Component({
  selector: "notfound",
  templateUrl: "./not-found.component.html"
})
export class NotFoundComponent {
  constructor() {}
}
